export default __webpack_public_path__ + "static/media/logo_sm.70579908.svg";